import React, { useState } from "react";
import axios from "axios";
import "./Newsletter.css";

const Newsletter = () => {
  const [email, setEmail] = useState(""); // State to hold email input

  const [showAlert, setShowAlert] = useState(false);

  // Handle email input change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  // Handle subscribe button click
  const handleSubscribe = () => {
    if (email) {
      // API call to save the subscription using object shorthand
      axios
        .post("https://api.dremerz.net/api/Kalanjiyam_User_Subscriptions", {
          email, // Object shorthand for { email: email }
        })
        .then((response) => {
          console.log(response);

          setShowAlert(true);
          setEmail(""); // Clear the input after successful subscription
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        })
        .catch((error) => {
          console.error("Error subscribing:", error);
          alert("Subscription failed. Please try again.");
        });
    } else {
      alert("Please enter a valid email address.");
    }
  };

  return (
    <div className=" newsletter-container container mt-5">
      <div className="row align-items-center">
        {/* Text Section */}
        <div className="col-md-6 newsletter-text">
          <h3 className="newsletter-heading">Newsletter</h3>
          <p className="newsletter-subheading">
            Subscribe to get information about products and coupons
          </p>
        </div>
        {/* Input Section */}
        <div className="col-md-6 newsletter-input-container">
          <div className="input-group">
            <input
              type="email"
              className="form-control newsletter-input"
              placeholder="Email address"
              aria-label="Email address"
              value={email}
              onChange={handleEmailChange} // Update email state on input change
            />
            <button
              className="btn newsletter-button"
              type="button"
              onClick={handleSubscribe} // Trigger subscribe on button click
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
      <div className="alertbox">
        {showAlert && (
          <div
            className="modal show"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" style={{ color: "#920504" }}>
                    Dear User
                  </h5>
                  {/* <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setShowAlert(false)}
                  ></button> */}
                </div>
                <div className="modal-body">
                  <p style={{ color: "#920504" }}>Subscribed successfully!</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Newsletter;
